import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import InteractionSessionTracking from './interactionSessionTracking';
export var INTERNAL_CLIENT_WINDOW_KEY = 'analyticsInteractionSesssionTrackingClient';
var GlobalInteractionSessionTracking = /*#__PURE__*/function () {
  function GlobalInteractionSessionTracking() {
    _classCallCheck(this, GlobalInteractionSessionTracking);
  }
  return _createClass(GlobalInteractionSessionTracking, null, [{
    key: "getInstance",
    value: function getInstance() {
      var interactionSessionTracking;
      try {
        // Check if InteractionSessionTracking in global window object
        if (INTERNAL_CLIENT_WINDOW_KEY in window) {
          interactionSessionTracking = window[INTERNAL_CLIENT_WINDOW_KEY];
        } else {
          // Initialise InteractionSessionTracking on global window object
          window[INTERNAL_CLIENT_WINDOW_KEY] = new InteractionSessionTracking();
          interactionSessionTracking = window[INTERNAL_CLIENT_WINDOW_KEY];
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error initialising InteractionSessionTracking - ".concat(error instanceof Error ? error.message : String(error)));
      }
      return interactionSessionTracking;
    }
  }]);
}();
export { GlobalInteractionSessionTracking as default };